module.exports = __webpack_public_path__ + "static/media/mastercard.8e8d0718.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/single/mastercard.svg
// module id = 494
// module chunks = 0